import { Breakpoint } from '@philips-internal/oswald-ui-constants';
import { getBreakpoint } from './index.js';
const mobileBreakpoints = [
    Breakpoint.SM,
    Breakpoint.XSM,
];
function isMobileResolution() {
    return mobileBreakpoints.includes(getBreakpoint());
}
export default isMobileResolution;
//# sourceMappingURL=is-mobile-resolution.js.map